import { apiFetch, getApiBaseStore } from "@/_helpers";
import app from "@/main";
import { _axios } from "@/plugins/axios";

export const tenantsService = {
  checkTenant,
  getSynccounter,
};

function checkTenant(name, store, type) {
  let url;
  let uri;
  if (name === "dev") {
    url = "http:\\\\127.0.0.1:8000";
  } else {
    url = "https:\\\\" + name + ".storesace.com";
  }
  uri = "dimas/api/core/info/?store=" + store;

  let requestOptions = {};
  app.$log.debug("API URL:", url);
  app.$log.debug("API URI:", uri);
  requestOptions = {
    method: "GET",
    baseURL: url,
    url: uri,
  };
  app.$log.debug(type);

  return _axios(requestOptions);
}

async function getSynccounter() {
  try {
    let fetchPath = "core/info/?store=" + getApiBaseStore();
    let result = await apiFetch(fetchPath);
    return result.synccounter;
  } catch (error) {
    app.$log.debug("Error fetching core synccounter:", error);
  }
}
